// removed by extract-text-webpack-plugin
module.exports = {"Orders":"Orders__Orders__OmRUy"};


//////////////////
// WEBPACK FOOTER
// ./src/components/orders/Orders.css
// module id = 6054
// module chunks = 0